import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, dark = false }) => (
  <span
    className="inline-flex items-center gap-3 text-xs font-body font-semibold uppercase tracking-[0.28em]"
    style={{ color: dark ? "#D89A18" : "#D89A18" }}
  >
    <span className="h-px w-8" style={{ background: "#D89A18" }} />
    {children}
  </span>
);
